import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import clsx from 'clsx';
import SavingIndicator from '../../components/SavingIndicator';
import styles from './PauseTransactionsDialog.style';

const PauseTransactionsDialog = ({
  onDismiss,
  onSubmit,
  name,
  isSubmitting,
  className,
  isDimensionList,
  isAdvanceGroup,
  isResubmit,
  ...other
}) => {
  const dimensionListDialogMessage = isResubmit
    ? 'Transaction processing of associated contracts will remain paused until list revision has been approved.'
    : 'This list is associated with active contracts which may trigger a transaction reprocessing event.';
  const advanceGroupDialogMessage =
    'Transaction processing of associated contracts will remain paused until contract has been re-approved.';

  const renderMessage = () => {
    if (isDimensionList) return <p className={styles.modalText}>{dimensionListDialogMessage}</p>;
    if (isAdvanceGroup) return <p className={styles.modalText}>{advanceGroupDialogMessage}</p>;
    return (
      <p className={styles.modalText}>
        Historical transactions may be reprocessed for royalty fee{' '}
        <span className={styles.modalBoldText}>{name}</span> upon approval. The processing of
        transactions will be pause until updates to the royalty fee are approved.
      </p>
    );
  };

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title: 'Pause Transactions',
        closeButtonAriaLabel: 'Close',
      }}
      modalProps={{
        className: clsx(styles.root, className),
      }}
      onDismiss={onDismiss}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      {...other}
    >
      {renderMessage()}
      <DialogFooter>
        <DefaultButton
          data-testid="pause-cancel-button"
          onClick={onDismiss}
          disabled={isSubmitting}
        >
          Cancel
        </DefaultButton>
        <PrimaryButton
          data-testid="pause-submit-button"
          type="submit"
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          {isDimensionList ? 'Agree' : 'Submit'}
        </PrimaryButton>
        {isSubmitting && <SavingIndicator className={styles.saving} />}
      </DialogFooter>
    </Dialog>
  );
};

PauseTransactionsDialog.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  name: PropTypes.string,
  isSubmitting: PropTypes.bool,
  className: PropTypes.string,
  isDimensionList: PropTypes.bool,
  isAdvanceGroup: PropTypes.bool,
  isResubmit: PropTypes.bool,
};

PauseTransactionsDialog.defaultProps = {
  name: '',
  isSubmitting: false,
  className: 'normal',
  isDimensionList: false,
  isAdvanceGroup: false,
  isResubmit: false,
};

export default PauseTransactionsDialog;
